import styled from 'styled-components';
import { Trans } from '@lingui/react';
import Icon from '@components/Icon';

const Text = styled.p`
  display: flex;
  align-items: center;
  color: #856404;
  font-size: 13px;
  font-weight: 500;
  border-radius: 3px;
  border: 1px solid #ffe597;
  padding: 10px 15px;
  margin-bottom: 0;
  background-color: #ffeeba;

  i {
    margin-right: 5px;
  }
`;

export const VideoBundleBanner = ({ className = '' }) => {
  return (
    <Text className={className}>
      <Icon name="ygb-icon-infob" fontSize="14px" />
      <Trans id="video.bundle_video_banner" />
    </Text>
  );
};
